define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        validation: {
            mt4_account_no: {
                required: false,
                min: 1
            },
            email:{
                required: true,
                pattern: 'email'
            }
        },

        labels:{
            mt4_account_no: "MT4 Account No.",
            email: "Email"
        }
    });
});
